import { render, staticRenderFns } from "./blockInfo.vue?vue&type=template&id=23f529d2&scoped=true&"
import script from "./blockInfo.vue?vue&type=script&lang=js&"
export * from "./blockInfo.vue?vue&type=script&lang=js&"
import style0 from "./blockInfo.vue?vue&type=style&index=0&id=23f529d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f529d2",
  null
  
)

export default component.exports